import { Button, Input, DatePicker } from "antd";
import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import Icon from "../Icon/Icon";
import Popup from "../Popup/Popup";

import { useConferencePopup } from "./useCoferencePopup";

import styles from './CoferencePopup.module.scss';

import { Props } from "./CoferencePopup.model";

const CoferencePopup = ({ conference, onClose, onSubmit }: Props) => {
	const {
		control,
		errors,
		handleSubmit,
		onSubmitForm
	} = useConferencePopup({ conference, onClose, onSubmit, });

	const intl = useIntl();

	return <Popup
		actions={<>
				<Button onClick={onClose} type="default" size="large"> 
					<FormattedMessage id="buttons.cancel" />
				</Button>
				<Button onClick={handleSubmit(onSubmitForm)} type="primary" size="large"> 
					<FormattedMessage id={conference ? "buttons.save" :"buttons.add"} />
				</Button>
			</>}
			title={{ action: '', target: conference ? 'editMeeting' : 'addMeeting' }}
			onClose={onClose}>
			<div className={styles.popupContent}>
				<div className={styles.category}>
					<div className={styles.categoryTitle}>
						<Icon name="file-edit" width="16px" color="light" type="solid"/>
						<h2><FormattedMessage id="formLabels.conferenceName"/></h2>
					</div>
					<div className={styles.fieldWrapper}>
						<span className={styles.floatingLabel}>
							<FormattedMessage id="formLabels.name" />
						</span>
						<Controller
							name="name"
							control={control}
							rules={{ required: true }}
							render={({ field }) => <Input className={errors.name && 'error'}  {...field} placeholder={intl.formatMessage({id: "formPlaceholders.name"})}/>}
						/>
					</div>
				</div>
				<div className={styles.category}>
					<div className={styles.categoryTitle}>
						<Icon name="calendar" width="16px" color="light" type="solid"/>
						<h2><FormattedMessage id="formLabels.conferenceDate" /></h2>
					</div>
					<div className={styles.fieldWrapper}>
						<span className={styles.floatingLabel}>
							<FormattedMessage id="formLabels.date" />
						</span>
						<Controller
							name="date"
							control={control}
							rules={{ required: true }}
							render={({ field }) => <DatePicker
								{...field}
								className={ errors.name && 'error'} 
								format='DD MMM YYYY'
								suffixIcon={false}
								style={{ padding: 0, width: '100%' }}
								picker='date'
							/>}
						/>
					</div>
				</div>
			</div>
		</Popup>
}

export default CoferencePopup;